import {Component} from '@angular/core';
import {RedirectService} from '../../services/redirect.service';
import {TranslateService} from '@ngx-translate/core';

@Component({
  standalone: false,
  selector: 'app-thank-you-without-documents',
  templateUrl: './thank-you-without-documents.component.html',
  styleUrls: ['./thank-you-without-documents.component.scss']
})
export class ThankYouWithoutDocumentsComponent {

  constructor(public redirectService: RedirectService,
              private translateService: TranslateService) {
  }

  openExternal(key: string) {
    this.redirectService.redirectTo(key);
  }
}
